import {
  Container,
  Grid,
  ThemeProvider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ITheme, theme } from "../constants/theme";

import { OrderedItemsListItem } from "../components-molecules";
import { PrintItemsButton } from "../components-atoms";
import { Fragment } from "react";
import { is_able_to } from "../utils/roles";
import { useTranslation } from 'react-i18next';

export const OrderDetailsOrderedItemsSection = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data, rejectItemPressed, resetQuantityPressed, loading } = props;
  return (
    <ThemeProvider theme={theme}>
      <Container className={classes.container} data-testid="ordered-items-section">
        <Grid container>
          <Grid container direction="row" className={classes.infoTitle}>
            <Grid item xs={8}>
              <Typography variant="h6" component="span" color="textPrimary">
                {t('orderDetails.orderedItems')}
              </Typography>
            </Grid>
            <Grid item container justifyContent="flex-end" xs={4}>
              {is_able_to("print_labels_again") && (
                <PrintItemsButton onClick={props.onPrintItemListClicked} disabled={loading} />
              )}
            </Grid>
          </Grid>
          <Grid container className={classes.orderedItemsContainer}>
            {data.Orderlines.map((item: any, index: any) => (
              <Fragment key={item.OrderLineId}>
                <OrderedItemsListItem
                  index={index}
                  item={item}
                  rejectItemPressed={rejectItemPressed}
                  resetQuantityPressed={resetQuantityPressed}
                  status={data.Status}
                  shopPortalStatus={data.ShopPortalStatus}
                  loading={loading}
                />
                {data.Orderlines.length - 1 === index ? (
                  <></>
                ) : (
                  <div className={classes.divider} />
                )}
              </Fragment>
            ))}
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 12px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    marginTop: "24px",
  },
  infoTitle: {
    marginBottom: 10,
  },
  orderedItemsContainer: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  printLabelsButton: {
    backgroundColor: theme.palette.primary.main,
    color: "rgba(255, 255, 255, 1)",
    textTransform: "none",
  },

  printButtonText: {
    textTransform: "none",
  },
  divider: {
    marginTop: "15px",
    marginBottom: "16px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    width: "100%",
  },
  fw400: {
    fontWeight: 400,
  },
}));
